import React from 'react';
import { Breakpoint } from '@moda/om';
import { LineItem } from '../../hooks/useCart/cart.rest';
import { LineItemListFull } from './LineItemListFull';
import { LineItemListMini } from './LineItemListMini';

type Props = {
  size?: 'mini' | 'full';
  theme?: 'box' | 'simple';
  title?: string;
  items: LineItem[];
};

export const LineItemList: React.FC<Props> = ({ size = 'full', theme, title, items }) => {
  if (size === 'mini')
    return <LineItemListMini granularity="minimal" title={title} theme={theme} items={items} />;

  return (
    <>
      <Breakpoint lt="md">
        <LineItemListMini title={title} theme={theme} items={items} />
      </Breakpoint>
      <Breakpoint gt="md">
        <LineItemListFull title={title} theme={theme} items={items} />
      </Breakpoint>
    </>
  );
};
